import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import axios from '../../../axios-dates/axios-dates';

import config from '../../../config.json';

import NewsBox from '../../../components/UI/NewsBox/NewsBox';
import TypeSelection from '../../../components/UI/TypeSelection/TypeSelection';
import Spinner from '../../../components/UI/Spinner/Spinner';

class TypeSelector extends Component {
  state = {
    consultationTypes: [],
    loading: true,
    error: null
  }

  typeSelectionHandler = (consultationType) => {
    this.props.onTypeSelect(consultationType);
    this.props.history.push({pathname: '/rs/select-slot/'});
  }

  componentDidMount () {
    axios.get('/rs/available-types.php')
      .then(res => {
        if (res.data.success) {
          const types = res.data.types.map(type => ({
            id: type.id,
            audience: type.audience,
            label: {
              'en': type.name_en,
              'de': type.name_de
            }
          }));
          const news = {
            'en': res.data.news_en,
            'de': res.data.news_de
          }
          this.setState({consultationTypes: types, news: news, loading: false});
        } else {
          this.setState({error: "Ein Server-Fehler ist aufgetreten: " + res.data.msg, loading: false});
        }
      })
      .catch(err => {
        this.setState({error: "Ein Server-Fehler ist aufgetreten: " + err.message, loading: false});
      })
  }

  render () {
    if (this.state.loading) {
      return <Spinner />;
    }
    return (
      <>
      {this.state.news[this.props.language] ?
        <NewsBox info={this.state.news[this.props.language]}/> : null
      }


      {this.state.error ? <p style={{color:'red'}}>{this.state.error}</p> :
      <TypeSelection
        audiences={config.audiences}
        consultationTypes={this.state.consultationTypes}
        buttonHandler={this.typeSelectionHandler}
        language={this.props.language} />
      }
      </>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTypeSelect: (consultationType) => dispatch({type: 'SELECT_TYPE', consultationType: consultationType})
  };
};

const mapStateToProps = (state) => {
  return {
    english: state.rs.english,
    language: state.rs.language
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TypeSelector));
